@if (!carregando) {
  <div class="container-fluid p-0" [@esvanecerDesvanecer]="'in'">
    <!-- Título -->
    <div class="borda_inferior bg-light pt-3 pr-4 pb-3 pl-4">
      <div class="d-flex flex-wrap justify-content-between">
        <div class="flex-grow-1 titulo_texto_posicao">
          @if (motivoPausa == null) {
            <div class="titulo_texto">Call Center - Novo Motivo (Pausa)</div>
          }
          @if (motivoPausa != null) {
            <div class="titulo_texto">Call Center - Alterar Motivo (Pausa)</div>
          }
        </div>
      </div>
    </div>
    <!-- Dados -->
    <div class="pt-3 pr-4 pb-4 pl-4">
      <form [formGroup]="formDados" (ngSubmit)="salvar()">
        <div class="form-row">
          <div class="form-group col-sm-6">
            <label><b>Motivo:</b></label>
            <input class="form-control form-control-sm" type="text" name="motivo" [ngClass]="{ 'is-invalid': enviado && f.motivo.errors?.required }" formControlName="motivo" />
            @if (enviado && f.motivo.errors?.required) {
              <div class="erro pt-1">Motivo em branco!</div>
            }
          </div>
          <div class="form-group col-sm-2">
            <label><b>Ativo:</b></label>
            <select class="form-control form-control-sm" name="ativo" #ativo (change)="selecionarMotivoPausaAtivo(ativo.value)">
              <option value="0" [selected]="!motivoPausaAtivo">Não</option>
              <option value="1" [selected]="motivoPausaAtivo">Sim</option>
            </select>
          </div>
          <div class="form-group col-sm-2">
            <label><b>Somente Gestor:</b></label>
            <select class="form-control form-control-sm" name="somente_gestor" #somente_gestor (change)="selecionarMotivoPausaSomenteGestor(somente_gestor.value)">
              <option value="0" [selected]="!motivoPausaSomenteGestor">Não</option>
              <option value="1" [selected]="motivoPausaSomenteGestor">Sim</option>
            </select>
          </div>
          <div class="form-group col-sm-2">
            <label><b>Tempo:</b></label>
            <ngb-timepicker name="motivoPausaTempo" [spinners]="false" [(ngModel)]="motivoPausaTempo" [ngModelOptions]="{ standalone: true }"></ngb-timepicker>
            @if (enviado && motivoPausaTempoInvalido) {
              <div class="erro pt-1">Tempo inválido!</div>
            }
          </div>
        </div>
        <hr class="mt-2 mb-2" />
        <div class="d-flex flex-wrap justify-content-between">
          <div class="flex-grow-1 text-right">
            <button class="btn btn-success btn_formulario" type="submit">Salvar</button>
          </div>
        </div>
      </form>
    </div>
  </div>
}
